export const styleConstants = {
    HEADER_HEIGHT: 60,
    HEADER_X_PADDING: 0,
    PADDING_X_HOME: 20,
    PADDING_Y_HOME: 10,
    PRIMARY_COLOR: "#FFFFFF",
    SECONDARY_COLOR: "#000000",
    BACKGROUND_COLOR_LAYOUT: "#000",
    FILTER_SIDEBAR_OPEN: '80px',
    FILTER_SIDEBAR_DEFAULT: '40px',
}

export const getAccountId = () => {
  let accountId;
  switch (globalThis.location?.hostname ?? "unknown") { 
    case 'tickets.soyoscaralarcon.com':
      accountId = 'oscar-alarcon';
      break;
    case 'sobreruedasok.com':
      accountId = 'sobre-ruedas-ok';
      break;
    case 'ganaconalonso.vercel.app':
      accountId = 'gana-con-alonso';
      break;
    case 'rifasellargo.vercel.app':
      accountId = 'rifas-el-largo';
      break;
    case 'rifaslosmou.vercel.app':
      accountId = 'rifas-los-mou';
      break;
    case 'samuelperalta.vercel.app':
      accountId = 'samuel-peralta';
      break;
    case 'ellerylux.vercel.app':
      accountId = 'rifas-el';
      break;
    case 'mototransformer.vercel.app':
      accountId = 'moto-transformer';
      break;
    case 'rifasellargo.com':
      accountId = 'rifas-el-largo';
      break;
    case 'rifas-jh-blessd.vercel.app':
      accountId = 'rifas-jh-blessd';
      break;
    case 'ganaconanthonyflow.vercel.app':
      accountId = 'anthony-flow';
      break;
    case 'cocinasinri.vercel.app':
      accountId = 'grow-dp';
      break;
    case 'elcieloesellimite.vercel.app':
      accountId = 'el-cielo-es-el-limite';
      break;
    case 'gerej16.com':
      accountId = 'gerej-16';
      break;
    case 'stephanieluxury.vercel.app':
      accountId = 'stephanie-luxury';
      break;
    case 'jj-platinum.vercel.app':
      accountId = 'jj-platinum';
      break;
    case 'bendecidosconvilla.vercel.app':
      accountId = 'bendecidos-con-villa';
      break;
    case 'unavisionrifas.vercel.app':
      accountId = 'una-vision';
      break;
    case 'fauiaguirre.vercel.app':
      accountId = 'galenstar';
      break;
    case 'goyo2time.com':
      accountId = 'goyo2time';
      break;
    case 'agudojhonny.vercel.app':
      accountId = 'agudojhonny';
      break;
    case 'rifasport.vercel.app':
      accountId = 'rifa-sport';
      break;
    case 'lasminasdebaruta.com':
    case 'lasminasdebaruta.vercel.app':
      accountId = 'minas-de-baruta';
      break;
    case 'soyoscaralarcon.com':
      accountId = 'oscar-alarcon-promo';
      break;
    case 'auroragraterol.vercel.app':
      accountId = 'aurora-graterol';
      break;
    case 'rifasbuenaventura.com':
      accountId = 'buenaventura';
      break;
    case 'apuestaconaleyjef.vercel.app':
      accountId = 'ale-jef';
      break;
    case 'maikel-dominguez.com':
      accountId = 'maikel-dominguez';
      break;
    case 'heroesdelaesperanza.vercel.app':
      accountId = 'blessed-disc-bar-zz';
      break;
    case 'danielcontrerasrifas.com':
      accountId = 'danielcontrerasrifas';
      break;
    case 'rifas.jaimezmaikel.com':
      accountId = 'maikel-jaimez';
      break;
    case 'luis-bigrau.vercel.app':
      accountId = 'luis-bigrau';
      break;
    case 'rifaslmg.com':
      accountId = 'rifas-lmg';
      break;
    case 'juegaconmariangel.com':
      accountId = 'w-robles';
      break;
    case 'rifas-cachorro.vercel.app':
      accountId = 'rifas-cachorro';
      break;
    case 'gnrifas.vercel.app':
      accountId = 'gn-rifas';
      break;
    case 'rifas-oriente.vercel.app':
      accountId = 'rifas-oriente';
      break;
    case 'yoiber-mota.vercel.app':
      accountId = 'yoiber-mota';
      break;
    case 'lavueltaesdios.vercel.app':
      accountId = 'lavueltaesdios';
      break;
    case 'antoni-contreras.vercel.app':
      accountId = 'antoni-contreras';
      break;
    case 'rifasmotorluck.com':
      accountId = 'motor-luck';
      break;
    case 'ganacongazu.vercel.app':
      accountId = 'gana-con-gazu';
      break;
    case 'zpremio.com':
      accountId = 'zpremio';
      break;
    case 'juegaconjgr.vercel.app':
      accountId = 'jgr1';
      break;
    case 'lotofer.vercel.app':
      accountId = 'lotofer';
      break;
    case 'ganaconmaurelinda.vercel.app':
      accountId = 'gana-con-maurelinda';
      break;
    case 'rifasjonaiker.vercel.app':
      accountId = 'rifas-jonaiker';
      break;
    case 'motopiruetasvnz.com':
      accountId = 'moto-piruetas-vnz';
      break;
    case 'flowshopccs.vercel.app':
      accountId = 'flow-shop';
      break;
    case 'rifaslosninos.com':
      accountId = 'los-ninos';
      break;
    case 'rifaselbarines.vercel.app':
      accountId = 'el-barines';
      break;
    case 'rifas-naguara.vercel.app':
      accountId = 'rifas-naguara';
      break;
    case 'rifasnaguarajc.com':
      accountId = 'rifas-naguara';
      break;
    case 'white-lion.vercel.app':
      accountId = 'white-lion';
      break;
    case 'ruedasextremas.vercel.app':
      accountId = 'ruedas-extremas';
      break;
    case 'elrifazo.vercel.app':
      accountId = 'el-rifazo';
      break;
    case 'localhost':
      accountId = 'rifa-sport';
      break;
    case 'rifasroalis.vercel.app':
      accountId = 'rifas-roalis';
      break;
    case 'lobovzla1.vercel.app':
      accountId = 'lobo-guarenas';
      break;
    case 'rifasloschamos.vercel.app':
      accountId = 'rifas-los-chamos';
      break;
    case 'rifaschente.vercel.app':
      accountId = 'rifas-chente';
      break;
    case 'apuestasvip58.vercel.app':
      accountId = 'a-donde-la-negra';
      break;
    case '2025easycars.vercel.app':
      accountId = 'easy-cars';
      break;
    case 'ganamosconantoni.net':
      accountId = 'ganamos-con-antoni';
      break;
    case 'monino.vercel.app':
      accountId = 'monino';
      break;
    case 'yourrmann.vercel.app':
      accountId = 'yourrmann';
      break;
    case 'alexvargas.vercel.app':
      accountId = 'alex-vargas';
      break;
    case 'rifasdeluxe1.com':
      accountId = 'rifas-deluxe';
      break;
    case 'eldeguarataroyilsongrau.vercel.app':
      accountId = 'yilson-grau';
      break;
    case 'franyerjar.vercel.app':
      accountId = 'franyer-jar';
      break;
    case 'eckojoyas.vercel.app':
      accountId = 'ecko-joyas';
      break;
    case 'alejandroelgochito.com':
      accountId = 'alejandro-el-gochito';
      break;
    case 'laguairamarket.vercel.app':
      accountId = 'la-guaira-market';
      break;
    case 'rifas23.vercel.app':
      accountId = 'rifas-23';
      break;
    case 'rifasloschacaros.vercel.app':
      accountId = 'rifas-los-chacaros';
      break;
    case 'emmanueldograu.vercel.app':
      accountId = 'emmanuel-dograu';
      break;
    case 'jfrifas.vercel.app':
      accountId = 'rifas-jf';
      break;
    case 'rifasloshermanos.vercel.app':
      accountId = 'rifas-los-hermanos';
      break;
    case 'ganaconjohnbi.vercel.app':
      accountId = 'gana-con-johnbi';
      break;
    case 'rifaselmono.vercel.app':
      accountId = 'el-mono';
      break;
    case 'angeelhr26.vercel.app':
      accountId = 'angel-hernandez';
      break;
    case 'jfrifas.com':
      accountId = 'rifas-jf';
      break;
    case 'rifastj.vercel.app':
      accountId = 'rifas-tj';
      break;
    case 'ganacongilberto.vercel.app':
      accountId = 'rifa-bera-2025';
      break;
    case 'ganaconleonardo.vercel.app':
      accountId = 'gana-con-leonardo';
      break;
    case 'rifasjj.com':
      accountId = 'rifas-jj';
      break;
    case 'tickets.ganaconsalazar.com':
      accountId = 'gana-con-salazar';
      break;
    case 'conlosmendozasegana.vercel.app':
      accountId = 'b-mendoza';
      break;
    case 'fuulldiesel.vercel.app':
      accountId = 'full-diesel';
      break;
    case 'losnietos.vercel.app':
      accountId = 'los-primos';
      break;
    case 'rifasdepaquete.vercel.app':
      accountId = 'rifas-de-paquete';
      break;
    case 'suenaengrande.vercel.app':
      accountId = 'suena-en-grande';
      break;
    case 'ganaconloscompadres.vercel.app':
      accountId = 'gana-con-los-compadres';
      break;
    case 'hernancitojr.vercel.app':
      accountId = 'hernancito-jr';
      break;
    case 'ganaconelcompay.vercel.app':
      accountId = 'carlos-pinango';
      break;
    case 'ganaconjesuito12.vercel.app':
      accountId = 'gana-con-jesuito';
      break;
    case 'rommy18.vercel.app':
      accountId = 'rommy-18';
      break;
    case 'rifalosprimos.vercel.app':
      accountId = 'rifa-los-primos';
      break;
    case 'wildliferescue.vercel.app':
      accountId = 'wild-life-rescue';
      break;
    case 'ganaconjuancho.vercel.app':
      accountId = 'gana-con-juancho';
      break;
    case 'puntoaltoikigai.vercel.app':
      accountId = 'punto-alto-ikigai';
      break;
    case 'elviejomotorepuestos.com':
      accountId = 'el-viejo';
      break;
    case 'ganaconlaurys.vercel.app':
      accountId = 'gana-con-laurys';
      break;
    case 'fsmrifas.vercel.app':
      accountId = 'fsm-rifas';
      break;
    case 'juegayganaconzapata.com':
      accountId = 'juega-con-zapata';
      break;
    case 'sandetusuerte.vercel.app':
      accountId = 'san-de-tu-suerte';
      break;
    case 'rifas-va.vercel.app':
      accountId = 'rifas-va';
      break;
    case 'larifadelexito.vercel.app':
      accountId = 'la-rifa-del-exito';
      break;
    case 'brotherifas.vercel.app':
      accountId = 'brotherifas';
      break;
    case 'notlicenciaprocess.vercel.app':
      accountId = 'not-licencia-process';
      break;
    case 'rifaslabotija.vercel.app':
      accountId = 'rifas-la-botija';
      break;
    case 'superifaslatam.vercel.app':
      accountId = 'super-rifas-latam';
      break;
    case 'larenovacion.vercel.app':
      accountId = 'la-renovacion';
      break;
    case 'gabopinto.vercel.app':
      accountId = 'gabo-pinto';
      break;
    case 'jayakuza.vercel.app':
      accountId = 'jayakuza';
      break;
    case 'rifasgritacaracas.vercel.app':
      accountId = 'grita-caracas';
      break;
    case 'ganaconibelles.vercel.app':
      accountId = 'gana-con-ibelles';
      break;
    case 'rifaloca.vercel.app':
      accountId = 'rifa-loca';
      break;
    case 'greko-rifando.vercel.app':
      accountId = 'greko-rifando';
      break;
    case 'ganaconbonis.vercel.app':
      accountId = 'gana-con-bonis';
      break;
    case 'rifasyaracuy.vercel.app':
      accountId = 'rifas-yaracuy';
      break;
    case 'ganaconluisdaniel.vercel.app':
      accountId = 'la-barberia';
      break;
    case 'rifasflowexotico.vercel.app':
      accountId = 'flow-exotico';
      break;
    case 'rifaslabuenaracha.com':
      accountId = 'la-buena-racha';
      break;
    case 'johan04eventos.vercel.app':
      accountId = 'johan-eventos';
      break;
    case 'gordoloto.com':
      accountId = 'gordoloto';
      break;
    case 'ganaconcarlasha.vercel.app':
      accountId = 'gana-con-carlasha';
      break;
    case 'djtito2025.vercel.app':
      accountId = 'dj-tito';
      break;
    case '2locosrifando.vercel.app':
      accountId = '2-locos-rifando';
      break;
    case 'ultraganador.vercel.app':
      accountId = 'ultra-ganador';
      break;
    case 'monolokura.com':
      accountId = 'mono-lokura';
      break;
    case 'eldelpuertorifas.vercel.app':
      accountId = 'el-del-puerto-rifas';
      break;
    case 'rifaselnay.vercel.app':
      accountId = 'el-nay';
      break;
    case 'jhonfrank-cordero.vercel.app':
      accountId = 'jhonfrank-cordero';
      break;
    case 'rifaselcharro.vercel.app':
      accountId = 'rifas-el-charro';
      break;
    case 'ganaconluxury.vercel.app':
      accountId = 'gana-con-luxury';
      break;
    case 'theshow2001.vercel.app':
      accountId = 'the-show-2001';
      break;
    case 'rifasjcc.com':
      accountId = 'rifas-jcc';
      break;
    case 'exirifas.vercel.app':
      accountId = 'exi-rifas';
      break;
    case 'dilangrau.vercel.app':
      accountId = 'dilan-grau';
      break;
    case 'tusuerteesnay.vercel.app':
      accountId = 'tu-suerte-es-nay';
      break;
    case 'diegomerchan10.vercel.app':
      accountId = 'diego-merchan';
      break;
    case 'kevinmunozrifas.vercel.app':
      accountId = 'kevin-munoz';
      break;
    case 'rifaspc.vercel.app':
      accountId = 'rifas-pc';
      break;
    case 'tusrifasrt.vercel.app':
      accountId = 'tus-rifas-rt';
      break;
    case 'antonyrifas.vercel.app':
      accountId = 'tony-12-grau';
      break;
    case 'rifasaldia.vercel.app':
      accountId = 'rifas-al-dia';
      break;
    case 'afortunados.vercel.app':
      accountId = 'afortunados';
      break;
    case 'elgranperrote.vercel.app':
      accountId = 'el-gran-perrote';
      break;
    case 'tugransueno.vercel.app':
      accountId = 'tu-gran-sueno';
      break;
    case 'rifaspetare.vercel.app':
      accountId = 'rifas-petare';
      break;
    case 'eldelah.vercel.app':
      accountId = 'el-de-la-h';
      break;
    case 'lotofamily.vercel.app':
      accountId = 'loto-family';
      break;
    case 'ellocojonder.vercel.app':
      accountId = 'el-loco-jonder';
      break;
    case 'sortealoyaoficial.com':
      accountId = 'rifalo-ya';
      break;
    case 'rifasrayray.vercel.app':
      accountId = 'ray-ray';
      break;
    case 'ganaconandrusthbarber.vercel.app':
      accountId = 'andrusth-barber';
      break;
    case 'billyysusrifas.vercel.app':
      accountId = 'billy-y-sus-rifas';
      break;
    case 'kevingal.vercel.app':
      accountId = 'rifas-kevingal';
      break;
    case 'rifas-11-11.vercel.app':
      accountId = 'rifas-11-11';
      break;
    case 'jose-pejic.vercel.app':
      accountId = 'jose-pejic';
      break;
    case 'victorarteaga.vercel.app':
      accountId = 'victor-arteaga';
      break;
    case 'rifasoriente.vercel.app':
      accountId = 'rifas-gran-oriente';
      break;
    case 'rifaselgordo.vercel.app':
      accountId = 'rifas-el-gordo';
      break;
    case 'leitolaguaira.vercel.app':
      accountId = 'leito-la-guaira';
      break;
    case 'erick-gomez.vercel.app':
      accountId = 'erick-gomez';
      break;
    case 'rifastalca.vercel.app':
      accountId = 'rifas-talca';
      break;
    case 'elpremioreal.vercel.app':
      accountId = 'alta-gama';
      break;
    case 'videosbraiker.vercel.app':
      accountId = 'videos-braiker';
      break;
    case 'jesuitomartinez.vercel.app':
      accountId = 'jesuito-martinez';
      break;
    case 'elcarteldelasrifas.vercel.app':
      accountId = 'el-cartel-de-la-rifa';
      break;
    case 'ganaconjohander.vercel.app':
      accountId = 'gana-con-johander';
      break;
    case 'sorteosdq.vercel.app':
      accountId = 'sorteos-dq';
      break;
    default:
      accountId = 'rifa-sport';
      break;
  }
  
  return accountId;
}

export const getPrimaryColorByAccountId = (accountId: string): string => {
  switch (accountId) {
    case "oscar-alarcon":
    case "sorteos-dq":
    case "samuel-peralta":
    case "la-barberia":
    case "gana-con-luxury":
    case "rifas-de-paquete":
    case "rommy-18":
    case "jj-platinum":
    case "una-vision":
    case "rifa-bera-2025":
    case "rifas-jj":
    case "gana-con-johnbi":
    case "el-loco-jonder":
    case "rifas-el-largo":
    case "diego-merchan":
    case "rifas-la-botija":
    case "tus-rifas-rt":
    case "rifas-los-hermanos":
    case "videos-braiker":
    case "gana-con-leonardo":
    case "rifas-tj":
    case "alta-gama":
    case "kevin-munoz":
    case "jhonfrank-cordero":
    case "gana-con-jesuito":
    case "el-de-la-h":
    case "gana-con-gazu":
    case "brotherifas":
      return "#FFFF00"
    case "super-rifas-latam":
    case "el-nay":
    case "gana-con-los-compadres":
      return "#8cc709"
    case "la-buena-racha":
      return "#ffd700"
    case "ultra-ganador":
      return "#572364"
    case "carlos-pinango":
    case "loto-family":
    case "billy-y-sus-rifas":
      return "#3e65ef"
    case "gordoloto":
    case "mono-lokura":
    case "jose-pejic":
    case "andrusth-barber":
    case "2-locos-rifando":
      return "#fb9e08"
    case "rifas-pc":
    case "rifas-al-dia":
      return "#3e984b"
    case "not-licencia-process":
    case "exi-rifas":
      return "#1b39e7"
    case "rifa-los-primos":
      return "#5be1e5"
    case "goyo2time":
    case "dilan-grau":
    case "erick-gomez":
    case "rifas-23":
    case "rifas-el-gordo":
    case "rifas-los-mou":
    case "gana-con-johander":
    case "agudojhonny":
    case "rifas-gran-oriente":
      return "#f80303"
    case "suena-en-grande":
    case "hernancito-jr":
    case "leito-la-guaira":
      return "#34b6fe"
    case "san-de-tu-suerte":
      return "#e3dd6e"
    case "minas-de-baruta":
      return "#20a2a3"
    case "oscar-alarcon-promo":
      return "#07FE9F"
    case "buenaventura":
      return "#0a662b"
    case "the-show-2001":
      return "#7b4696"
    case "maikel-dominguez":
    case "yoiber-mota":
    case "rifas-kevingal":
      return "#EA6F06"
    case "white-lion":
      return "#e5a939"
    case "maikel-jaimez":
      return "#fff"
    case "afortunados":
      return "#db926b"
    case "el-rifazo":
    case "victor-arteaga":
    case "rifas-los-chacaros":
      return "#3367d6"
    case "rifas-oriente":
    case "greko-rifando":
    case "danielcontrerasrifas":
    case "grow-dp":
    case "gana-con-bonis":
    case "gn-rifas":
      return "#9fc5e8"
    case "la-guaira-market":
      return "#6db336"
    case "rifa-sport":
    case "vip-rifas":
    case "gabo-pinto":
    case "rifas-yaracuy": 
    case "gana-con-alonso": 
    case "rifa-loca":
        return "#1cbb35"
    case "motor-luck":
    case "flow-exotico":
    case "zpremio":
      return "#e5a939";
    case "jjmc":
      return "#000"
    case "rifas-trebol":
    case "el-gran-perrote":
    case "grita-caracas":
    case "anthony-flow":
    case "el-mono":
    case "tu-suerte-es-nay":
    case "la-rifa-del-exito":
      return "#196b3c"
    case "easy-cars":
      return "#e6992a"
    case "a-donde-la-negra":
    case "fsm-rifas":
    case "rifas-el":
      return "#32c0cc"
    case "luis-bigrau":
      return "#FFFF00"
    case "rifas-jonaiker":
    case "ruedas-extremas":
    case "rifas-roalis":
    case "moto-transformer":
    case "moto-piruetas-vnz":
    case "rifas-petare":
    case "tony-12-grau":
    case "dj-tito":
    case "gana-con-ibelles":
    case "blessed-disc-bar-zz":
    case "jayakuza":
    case "rifalo-ya":
    case "el-del-puerto-rifas":
    case "rifas-jh-blessd":
    case "johan-eventos":
      return "#d73533"
    case "antoni-contreras":
    case "juega-con-zapata":
    case "franyer-jar":
      return "#1a389c"
    case "flow-shop":
      return "#fff"
    case "yilson-grau":
    case "ale-jef":
    case "aurora-graterol":
      return "#1d2eef"
    case "rifas-lmg":
    case "gana-con-salazar":
      return "#2e2ed2"
    case "rifas-va": 
      return "#d8dc03"
    case "rifas-naguara":
    case "los-primos":
    case "el-viejo":
    case "gerej-16":
    case "gana-con-juancho":
    case "wild-life-rescue":
    case "monino":
    case "galenstar":
    case "full-diesel":
    case "alejandro-el-gochito":
    case "emmanuel-dograu":
    case "lobo-guarenas":
      return "#c72534"
    case "gana-con-carlasha":
    case "gana-con-maurelinda":
      return "#ffb5c0"
    case "rifas-los-chamos":
    case "el-barines":
      return "#fd6f49"
    case "bendecidos-con-villa":
    case "el-cartel-de-la-rifa":
      return "#0185d6"
    case "lavueltaesdios":
      return "#66161f"
    case "ganamos-con-antoni":
    case "w-robles":
      return "#327add"
    case "rifas-deluxe":
    case "rifas-el-charro":
    case "angel-hernandez":
    case "la-renovacion":
    case "alex-vargas":
    case "rifas-jf":
    case "tu-gran-sueno":
    case "stephanie-luxury":
    case "sobre-ruedas-ok":
    case "ray-ray":
    case "rifas-11-11":
    case "punto-alto-ikigai":
    case "rifas-talca":
    case "b-mendoza":
    case "ecko-joyas":
    case "rifas-chente":
    case "rifas-jcc":
      return "#b98932"
    case "gana-con-laurys":
      return "#72ac3b"
    case "los-ninos":
    case "jgr1":
    case "lotofer":
      return "#1D4293"
    default: 
      return "#72ac3b"
  }
}

export const getThemeByAccountId = (accountId: string): "dark" | "light" => {
  switch (accountId) {
    case "oscar-alarcon":
    case "kevin-munoz":
    case "gana-con-leonardo":
    case "jj-platinum":
    case "una-vision":
    case "galenstar":
    case "buenaventura":
    case "ale-jef":
    case "yourrmann":
    case "gana-con-salazar":
    case "oscar-alarcon-promo":
    case "danielcontrerasrifas":
    case "vip-rifas":
    case "maikel-dominguez":
    case "blessed-disc-bar-zz":
    case "rifa-sport":
    case "rifas-chente":
    case "ganamos-con-antoni":
    case "maikel-jaimez":
    case "goyo2time":
    case "rifas-trebol":
    case "gn-rifas":
    case "wild-life-rescue":
    case "rifas-naguara":
      return "dark"
    case "jjmc":
    case "white-lion":
    case "agudojhonny":
    case "jesuito-martinez":
    case "suena-en-grande":
    case "gana-con-carlasha":
    case "alex-vargas":
    case "la-buena-racha":
    case "bendecidos-con-villa":
    case "greko-rifando":
    case "rifas-roalis":
    case "jgr1":
      return "light"
    default: 
      return "dark"
  }
}

export const buttonAddStyle = {
    mt: 2,
    marginLeft: 1,
    padding: 0,
    border: 0,
    textDecoration: "underline",
  };